export default "__VITE_ASSET__9c8f85bb__"